import React from 'react';
import {connect} from 'react-redux';
import {setFilter} from "../../redux/actions";
import {setLanguage, toggleLanguageMenu} from '../../redux/actions';
import useWindowDimensions from "../../hooks/useWindowDimensions";

const LanguageItem = props => {
    const {currentFilter, setFilter} = props;
    const {width} = useWindowDimensions();

    const setLanguageHandler = () => {
        //debugger;
        let {language} = props;
        if (props.configuration.domesticPolicy && props.configuration.domesticLanguages[props.language.code + "-dom"]) {
            //debugger;
            language = props.configuration.domesticLanguages[props.language.code + "-dom"];
        }
        props.setLanguage(language);
        props.toggleLanguageMenu(!props.isLanguageMenuOpen);

        // Change language of the filter
        if (currentFilter) {
            setFilter({
                filterName: currentFilter.filterName,
                value: language.vendorList[currentFilter.filterName]
                    .find(filter => filter.id === currentFilter.value.id)
            });
        }
    }

    return (
        <li onClick={setLanguageHandler}>
            <div className={props.className}>{width > 576 ? props.title : props.languageCode}</div>
        </li>
    );
};

const mapStateToProps = state => {
    return {...state};
};

export default connect(mapStateToProps, {setFilter, setLanguage, toggleLanguageMenu})(LanguageItem);